import arobaAxiosInstance from '@/services/axios/aroba-axios.service';
const baseDomain = process.env.VUE_APP_API_BASE_URL;
/**
 * Initialize the web push notification service
 */
export const initWebPushNotifiacation = async () => {
  let status = 'isDemo';
  if (status === 'isDemo') {
    return Promise.resolve();
  }
  if ('serviceWorker' in navigator) {
    /**
     * Comunicate with service worker
     */
    navigator.serviceWorker.ready.then(async (registration) => {
      console.log(`A service worker is active: ${registration.active}`);
      let currentServiceWorker = null;
      if (navigator.serviceWorker.controller) {
        currentServiceWorker = navigator.serviceWorker.controller;
      } else {
        currentServiceWorker = registration.active;
      }
      const messageChannel = new MessageChannel();
      // First we initialize the channel by sending
      // the port to the Service Worker (this also
      // transfers the ownership of the port)
      currentServiceWorker.postMessage(
        {
          type: 'INIT_PORT',
        },
        [messageChannel.port2]
      );
      //Get VAPID public key for push notification
      const resVapid = await arobaAxiosInstance.get(
        baseDomain + '/ccs/v1/notification/vapidPublicKey',
        {
          headers: {
            'content-type': 'application/json',
          },
        }
      );
      currentServiceWorker.postMessage({
        type: 'SW_INIT_WEB_PUSH_NOTIFICATION',
        payload: { publicKey: resVapid.data.publicKey },
      });

      // Listen to the response
      messageChannel.port1.onmessage = (event) => {
        if (event.data.type === 'SUBSCRIBE') {
          arobaAxiosInstance.post(
            process.env.VUE_APP_API_BASE_URL +
              '/ccs/v1/notification/webpushSubscribe',
            JSON.parse(event.data.payload)
          );
        }
      };
    });
  }
};
